/* eslint-disable */
/* global jQuery, Shopify */
(function() {
  function initPopularProductTabs(event) {
    const sections = document.querySelectorAll('.popular-products-tabs');
  
  sections.forEach(section => {
    // Check if we are loading a specific section via Theme Editor
    if (event && event.type === 'shopify:section:load') {
      if (section.dataset.sectionId !== event.detail.sectionId) {
        return; 
      }
    }
    
    if (section.dataset.initialized === 'true' && (!event || event.type !== 'shopify:section:load')) {
       return;
    }
    section.dataset.initialized = 'true';

    const perPage = parseInt(section.dataset.productsPerPage, 10) || 8;

    function startPopularProductsTabs() {
      const tabs = section.querySelectorAll('.popular-tab-btn');
      const contents = section.querySelectorAll('.popular-tab-content');
      const prevTabBtn = section.querySelector('.prev-tab');
      const nextTabBtn = section.querySelector('.next-tab');

      section.querySelectorAll('.filter-wrapper').forEach(wrapper => {
        const btn = wrapper.querySelector('button, a.search-btn, .filter-search-btn');
        const selects = wrapper.querySelectorAll('.filter-select');
        const tabId = wrapper.id.replace('filters-', 'tab-');
        
        function applyFilters() {
          const container = section.querySelector('#' + tabId);
          if (!container) return;

          const cards = container.querySelectorAll('.popular-product-card');
          const activeFilters = [];

          selects.forEach(select => {
            const value = select.value;
            if (value) {
              activeFilters.push({
                param: select.getAttribute('data-filter') || (select.classList.contains('price-filter') ? 'price' : ''),
                value: value,
                isPrice: select.classList.contains('price-filter')
              });
            }
          });

          cards.forEach(card => {
            let show = true;
            activeFilters.forEach(filter => {
              if (filter.isPrice) {
                const price = parseFloat(card.getAttribute('data-price')) || 0;
                let min = 0, max = Infinity;
                if (filter.value === '0-50') max = 50;
                else if (filter.value === '50-100') { min = 50; max = 100; }
                else if (filter.value === '100-200') { min = 100; max = 200; }
                if (price < min || price > max) show = false;
              } else {
                let attrName = '';
                if (filter.param === 'filter.p.vendor') attrName = 'data-vendor';
                else if (filter.param === 'filter.p.product_type') attrName = 'data-product-type';
                else if (filter.param === 'filter.v.availability') attrName = 'data-available';
                else if (filter.param && filter.param.startsWith('filter.v.option.')) {
                  attrName = 'data-option-' + filter.param.replace('filter.v.option.', '').toLowerCase().replace(/ /g, '-');
                } else if (filter.param && filter.param.startsWith('filter.p.tag')) {
                  attrName = 'data-tag-' + filter.value.toLowerCase().replace(/ /g, '-');
                }

                if (attrName) {
                  let checkValue = filter.value.toLowerCase();
                  if (attrName === 'data-available') {
                    checkValue = checkValue === '1' ? 'true' : (checkValue === '0' ? 'false' : checkValue);
                  }
                  if (attrName.startsWith('data-tag-')) {
                     if (card.getAttribute(attrName) !== 'true') show = false;
                  } else {
                    const cardAttr = card.getAttribute(attrName);
                    if (!cardAttr || !cardAttr.toLowerCase().split(',').includes(checkValue)) {
                      show = false;
                    }
                  }
                }
              }
            });

            if (show) {
              card.classList.remove('filtered-out');
            } else {
              card.classList.add('filtered-out');
            }
          });

          paginate(tabId);
        }

        if (btn) {
          btn.addEventListener('click', function(e) {
            e.preventDefault();
            applyFilters();
          });
        } else {
          selects.forEach(select => {
            select.addEventListener('change', applyFilters);
          });
        }
      });

      if (!section.dataset.globalListenerAttached) {
        document.addEventListener('change', function(e) {
          if (e.target.closest('.custom-filters input')) {
            const activeTabBtn = section.querySelector('.popular-tab-btn.active');
            if (!activeTabBtn) return;
            const tabId = activeTabBtn.dataset.tab;
            const container = section.querySelector('#' + tabId);
            if (!container) return;

            const activeFilter = section.querySelector('#filters-' + tabId.replace('tab-', ''));
            if (!activeFilter) return;

            const cards = container.querySelectorAll('.popular-product-card');
            const inputs = activeFilter.querySelectorAll('.custom-filters input');
            const activeFilters = [];
            
            inputs.forEach(input => {
              if (input.type === 'checkbox' && input.checked) {
                activeFilters.push({ param: input.name, value: input.value });
              }
            });
            
            let minPrice = parseFloat(activeFilter.querySelector('input[name="filter.v.price.gte"]')?.value) || 0;
            let maxPrice = parseFloat(activeFilter.querySelector('input[name="filter.v.price.lte"]')?.value) || Infinity;
            
            cards.forEach(card => {
              let show = true;
              const price = parseFloat(card.getAttribute('data-price')) || 0;
              if (price < minPrice || price > maxPrice) show = false;

              if (show && activeFilters.length > 0) {
                const grouped = {};
                activeFilters.forEach(f => {
                   if (!grouped[f.param]) grouped[f.param] = [];
                   grouped[f.param].push(f.value.toLowerCase());
                });
                
                for (const param in grouped) {
                  let allowedValues = grouped[param];
                  let attrName = '';
                  if (param === 'filter.p.vendor') attrName = 'data-vendor';
                  else if (param === 'filter.p.product_type') attrName = 'data-product-type';
                  else if (param === 'filter.v.availability') {
                    attrName = 'data-available';
                    allowedValues = allowedValues.map(v => v === '1' ? 'true' : (v === '0' ? 'false' : v));
                  } else if (param.startsWith('filter.v.option.')) {
                    attrName = 'data-option-' + param.replace('filter.v.option.', '').toLowerCase().replace(/ /g, '-');
                  } else if (param.startsWith('filter.p.m.')) {
                    // Best effort for metafields if data attributes exist
                    attrName = 'data-metafield-' + param.split('.').pop().toLowerCase().replace(/ /g, '-');
                  } else if (param.startsWith('filter.p.tag')) {
                    attrName = 'data-tag'; // Special case for tags, value check is different
                  }
                  
                  if (attrName === 'data-tag') {
                    // For tags, the data attribute itself is the tag name, e.g., data-tag-red="true"
                    const hasMatch = allowedValues.some(val => {
                      const tagAttr = 'data-tag-' + val.toLowerCase().replace(/ /g, '-');
                      return card.getAttribute(tagAttr) === 'true';
                    });
                    if (!hasMatch) show = false;
                  } else if (attrName) {
                    const cardAttr = card.getAttribute(attrName);
                    if (!cardAttr) {
                      show = false;
                    } else {
                      const cardValues = cardAttr.toLowerCase().split(',');
                      const hasMatch = allowedValues.some(val => cardValues.includes(val));
                      if (!hasMatch) show = false;
                    }
                  }
                }
              }
              
              if (show) card.classList.remove('filtered-out');
              else card.classList.add('filtered-out');
            });

            paginate(tabId);
          }
        });
        section.dataset.globalListenerAttached = 'true';
      }

      tabs.forEach(tab=>{
        tab.addEventListener('click', ()=>{
          const target = tab.dataset.tab;

          tabs.forEach(t => t.classList.remove('active'));
          contents.forEach(c => c.classList.remove('active'));

          section.querySelectorAll('.filter-wrapper').forEach(f => {
            f.classList.remove('active');
          });

          tab.classList.add('active');

          const targetContainer = section.querySelector('#' + target);
          if (targetContainer) {
            targetContainer.classList.add('active');
          }

          const activeFilter = section.querySelector(
            '#filters-' + tab.dataset.tab.replace('tab-', '')
          );

          if(activeFilter){
            activeFilter.classList.add('active');
          }

          paginate(target);
          updateTabArrows();
        });
      });

      function getActiveTabIndex(){
        return Array.from(tabs).findIndex(t => t.classList.contains('active'));
      }

      function switchTab(index){
        if(index < 0 || index >= tabs.length) return;

        const tab = tabs[index];
        const target = tab.dataset.tab;

        tabs.forEach(t => t.classList.remove('active'));
        contents.forEach(c => c.classList.remove('active'));

        section.querySelectorAll('.filter-wrapper').forEach(f => {
          f.classList.remove('active');
        });

        tab.classList.add('active');

        const targetContainer = section.querySelector('#' + target);
        if(targetContainer) {
          targetContainer.classList.add('active');
        }

        const activeFilter = section.querySelector(
          '#filters-' + target.replace('tab-', '')
        );

        if(activeFilter){
          activeFilter.classList.add('active');
        }

        paginate(target);
        updateTabArrows();
      }

      function updateTabArrows(){
        if(!prevTabBtn || !nextTabBtn) return;
        const index = getActiveTabIndex();

        prevTabBtn.disabled = index === 0;
        nextTabBtn.disabled = index === tabs.length - 1;
      }

      if(prevTabBtn) {
        prevTabBtn.addEventListener('click', () => {
          const index = getActiveTabIndex();
          switchTab(index - 1);
        });
      }

      if(nextTabBtn) {
        nextTabBtn.addEventListener('click', () => {
          const index = getActiveTabIndex();
          switchTab(index + 1);
        });
      }

      function paginate(tabId){
        const container = section.querySelector('#'+tabId);
        if(!container) return;

        const owlContainer = container.querySelector('.popular-products-grid');
        const isDesktop = window.innerWidth > 768;

        if (isDesktop) {
          destroyOwl(owlContainer);
          if (owlContainer) owlContainer.classList.remove('owl-carousel');
        } else {
          destroyOwl(owlContainer);
          if (owlContainer) owlContainer.classList.add('owl-carousel');
        }

        const allCardsArray = Array.from(container.querySelectorAll('.popular-product-card'));
        const cards = allCardsArray.filter(c => !c.classList.contains('filtered-out'));

        const pagination = container.querySelector('.pagination-wrapper');

        let currentPage = 1;

        function render(){
          let start = (currentPage-1)*perPage;
          let end = start+perPage;

          allCardsArray.forEach(c => {
            c.classList.remove('item');
            c.style.display = 'none';
          });

          cards.forEach((card,i)=>{
            card.style.display = (i>=start && i<end) ? 'flex':'none';
          });

          renderButtons();
        }

        function renderButtons(){
          if (!pagination) return;
          const pages = Math.ceil(cards.length / perPage);
          pagination.innerHTML = '';

          if (pages <= 1) return; // Hide pagination if only 1 page

          // PREV BUTTON
          const prevBtn = document.createElement('button');
          prevBtn.innerHTML = document.getElementById('icon-prev-btn').innerHTML;
          prevBtn.className = 'page-btn prev-btn';
          prevBtn.disabled = currentPage === 1;
          
          prevBtn.addEventListener('click', () => {
            if (currentPage > 1) {
              currentPage--;
              render();
              section.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
          });

          pagination.appendChild(prevBtn);

          // NUMBER BUTTONS
          function getPaginationArray(c, m) {
            let delta = 1,
                left = c - delta,
                right = c + delta + 1,
                range = [],
                rangeWithDots = [],
                l;

            if (m <= 7) {
                for (let i = 1; i <= m; i++) range.push(i);
                return range;
            }

            if (c <= 3) {
                left = 1;
                right = 6;
            } else if (c >= m - 2) {
                left = m - 4;
                right = m + 1;
            }

            for (let i = 1; i <= m; i++) {
                if (i == 1 || i == m || i >= left && i < right) {
                    range.push(i);
                }
            }

            for (let i of range) {
                if (l) {
                    if (i - l === 2) {
                        rangeWithDots.push(l + 1);
                    } else if (i - l !== 1) {
                        rangeWithDots.push('...');
                    }
                }
                rangeWithDots.push(i);
                l = i;
            }

            return rangeWithDots;
          }

          const paginationItems = getPaginationArray(currentPage, pages);

          paginationItems.forEach(i => {
            if (i === '...') {
              const span = document.createElement('span');
              span.innerText = '...';
              span.className = 'page-btn';
              span.style.cursor = 'default';
              pagination.appendChild(span);
            } else {
              const btn = document.createElement('button');
              btn.innerText = i;
              btn.className = 'page-btn' + (i === currentPage ? ' active' : '');

              btn.addEventListener('click', () => {
                currentPage = i;
                render();
                section.scrollIntoView({ behavior: 'smooth', block: 'start' });
              });

              pagination.appendChild(btn);
            }
          });

          // NEXT BUTTON
          const nextBtn = document.createElement('button');
          nextBtn.innerHTML = document.getElementById('icon-next-btn').innerHTML;
          nextBtn.className = 'page-btn next-btn';
          nextBtn.disabled = currentPage === pages;
          
          nextBtn.addEventListener('click', () => {
            if (currentPage < pages) {
              currentPage++;
              render();
              section.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
          });

          pagination.appendChild(nextBtn);
        }

        if (isDesktop) {
          render();
        } else if (owlContainer) {
          cards.forEach((card) => {
            card.style.display = '';
            card.classList.add('item');
          });
          if (pagination) pagination.innerHTML = '';
          let owlAttempts = 0;
          function tryOwl() {
            owlAttempts++;
            if (typeof jQuery === 'undefined' || !jQuery.fn.owlCarousel) {
              if (owlAttempts < 100) setTimeout(tryOwl, 100);
              return;
            }
            if (owlContainer.offsetParent !== null) {
              initOwl(owlContainer);
            }
          }
          tryOwl();
        }
      }

      function destroyOwl(owlContainer) {
        if (!owlContainer || typeof jQuery === 'undefined') return;
        const $el = jQuery(owlContainer);
        if ($el.hasClass('owl-loaded')) {
          $el.trigger('destroy.owl.carousel');
          $el.removeClass('owl-loaded owl-hidden');
          if ($el.find('.owl-stage-outer').length) {
            $el.find('.owl-stage-outer').children().unwrap();
          }
        }
      }

      function initOwl(owlContainer) {
        if (!owlContainer || typeof jQuery === 'undefined' || !jQuery.fn.owlCarousel) return;
        if (owlContainer.offsetParent === null) return;
        if (owlContainer.dataset.owlInitializing === 'true') return;
        owlContainer.dataset.owlInitializing = 'true';

        try {
          const $el = jQuery(owlContainer);

          if ($el.hasClass('owl-loaded')) {
            $el.trigger('destroy.owl.carousel');
            $el.removeClass('owl-hidden');
          }

          if ($el.children('.item').length === 0) {
            owlContainer.dataset.owlInitializing = 'false';
            return;
          }

          $el.owlCarousel({
            loop: true,
            margin: 10,
            responsiveClass: true,
            responsive: {
              0: {
                items: 1,
                nav: false,
                dots: true
              },
              600: {
                items: 2,
                nav: false,
                dots: true
              },
              1000: {
                items: 5,
                nav: false,
                dots: true,
                loop: false
              }
            }
          });
        } catch (e) {
          console.error('Owl init error:', e);
        }
        owlContainer.dataset.owlInitializing = 'false';
      }

      if (tabs.length > 0) {
        const first = tabs[0].dataset.tab;
        paginate(first);
      }
      
      // ── Handle Window Resize (DevTools / Device Rotation) ──────────────────
      let currentWidth = window.innerWidth;
      window.addEventListener('resize', function() {
        if (window.innerWidth !== currentWidth) {
          const crossedBreakpoint = (currentWidth > 768 && window.innerWidth <= 768) || (currentWidth <= 768 && window.innerWidth > 768);
          currentWidth = window.innerWidth;
          
          if (crossedBreakpoint) {
            const activeTabBtn = section.querySelector('.popular-tab-btn.active');
            if (activeTabBtn) {
              clearTimeout(section.resizeTimer);
              section.resizeTimer = setTimeout(() => {
                paginate(activeTabBtn.dataset.tab);
              }, 150);
            }
          }
        }
      });


    }

    const addToCartForms = section.querySelectorAll('form[action$="/cart/add"]');
    addToCartForms.forEach(form => {
      form.addEventListener('submit', function(e) {
        e.preventDefault();
        const btn = form.querySelector('button[type="submit"]');
        if (btn) {
          btn.disabled = true;
          btn.style.opacity = '0.5';
        }

        fetch((window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/') + 'cart/add.js', {
          method: 'POST',
          body: new FormData(form)
        })
        .then(response => response.json())
        .then(cart => {
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart } }));
          document.dispatchEvent(new CustomEvent('cart:refresh'));
          document.documentElement.dispatchEvent(new CustomEvent('cart:change', { bubbles: true }));
          document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { product: cart } }));

          const cartIcon = document.querySelector('a[href="/cart"], .header__icon--cart, #cart-icon');
          if (cartIcon && typeof cartIcon.click === 'function') {
            cartIcon.click();
          }
        })
        .catch(error => console.error('Error adding to cart:', error))
        .finally(() => {
          if (btn) {
            btn.disabled = false;
            btn.style.opacity = '1';
          }
        });
      });
    });

    startPopularProductsTabs();
  });
}

// Global Event Listeners to ensure proper loading
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initPopularProductTabs);
} else {
  // DOM is already ready, initialize immediately
  initPopularProductTabs();
}

document.addEventListener('shopify:section:load', initPopularProductTabs);

// Also try executing immediately in case the script is loaded dynamically without defer
initPopularProductTabs();

})();
